import React, { useState } from "react";
import { Modal, Input, List } from "antd";
import "./CountrySelectorModal.scss";

interface Country {
  code: string;
  dial: string;
  name: string;
  flag: string;
}

interface CountrySelectorModalProps {
  visible: boolean;
  onClose: () => void;
  onSelect: (country: Country) => void;
}

const countries: Country[] = [
  {
    code: "US",
    dial: "+1",
    name: "United States",
    flag: "https://flagcdn.com/us.svg",
  },
  {
    code: "CA",
    dial: "+1",
    name: "Canada",
    flag: "https://flagcdn.com/ca.svg",
  },
];

const CountrySelectorModal: React.FC<CountrySelectorModalProps> = ({
  visible,
  onClose,
  onSelect,
}) => {
  const [search, setSearch] = useState<string>("");

  const filteredCountries = countries.filter(
    (country) =>
      country.name.toLowerCase().includes(search.toLowerCase()) ||
      country.dial.includes(search)
  );

  return (
    <Modal
      title="Select Country"
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      className="countries-selector-modal custom-modal"
    >
      <Input
        className="search-input"
        placeholder="Search..."
        onChange={(e) => setSearch(e.target.value)}
        allowClear
      />
      <List
        className="countries-list"
        dataSource={filteredCountries}
        renderItem={(country) => (
          <List.Item
            key={country.code}
            onClick={() => onSelect(country)}
            style={{
              cursor: "pointer",
              display: "grid",
              gridTemplateColumns: "repeat(3 ,1fr)",
              alignItems: "center",
            }}
          >
            <div className="flag-wrapper">
              <img src={country.flag} alt="flag"/>
            </div>
            <span>{country.dial}</span>
            <span>{country.name}</span>
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default CountrySelectorModal;
